import { render, staticRenderFns } from "./CheckLogin.vue?vue&type=template&id=2c215320&scoped=true&"
import script from "./CheckLogin.vue?vue&type=script&lang=js&"
export * from "./CheckLogin.vue?vue&type=script&lang=js&"
import style0 from "./CheckLogin.vue?vue&type=style&index=0&id=2c215320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c215320",
  null
  
)

export default component.exports